
import React from 'react';
import { Link } from 'react-router-dom';

const KeyChallenges: React.FC = () => {
  return (
    <section>
      <h2 className="text-2xl font-bold text-itmgmt-dark-blue mb-6">Key Technology Challenges in Real Estate</h2>
      
      <p className="mb-4 text-gray-700 leading-relaxed">
        Before diving into the solutions, it's important to understand the specific technology challenges 
        that real estate agencies face today:
      </p>
      
      <ul className="list-disc pl-6 mb-6 space-y-3 text-gray-700">
        <li className="leading-relaxed">
          <strong>Client Expectations:</strong> Today's property buyers and sellers expect seamless digital 
          experiences, from virtual tours to electronic document signing and regular digital communication.
        </li>
        <li className="leading-relaxed">
          <strong>Inefficient Workflows:</strong> Many agencies still rely on manual processes for listing 
          management, document handling, and client communications, creating bottlenecks and reducing agent productivity.
        </li>
        <li className="leading-relaxed">
          <strong>Data Management:</strong> Real estate transactions generate substantial amounts of data 
          that need to be securely stored, organized, and easily retrievable for future reference, similar to the challenges faced by
          <Link to="/blog/secure-document-management-cpa-firms" className="text-itmgmt-bright-blue hover:underline"> accounting firms</Link>.
        </li>
        <li className="leading-relaxed">
          <strong>Remote Work Requirements:</strong> With more agents working remotely or on-the-go, 
          agencies need technology that enables productivity from anywhere while maintaining security.
        </li>
        <li className="leading-relaxed">
          <strong>Marketing Effectiveness:</strong> Standing out in a crowded market requires sophisticated 
          digital marketing tools that can highlight properties and reach targeted audiences.
        </li>
        <li className="leading-relaxed">
          <strong>Security Concerns:</strong> The sensitive financial and personal data involved in real estate transactions makes agencies 
          prime targets for cybercriminals, requiring robust <Link to="/services/cybersecurity" className="text-itmgmt-bright-blue hover:underline">cybersecurity solutions</Link>.
        </li>
      </ul>
    </section>
  );
};

export default KeyChallenges;
